import { gql } from '@apollo/client';

export const ALL_DISTRICT_MUNICIPALITIES = gql`
  query AllDistrictMunicipalities($input: FilterDistrictMunicipalitiesInput!) {
    municipalities: getDistrictMunicipalities(input: $input) {
      id
      name
    }
  }
`;
